require("../scss/style.scss");

const $ = (jQuery = require("jquery"));
const Cookies = require("js-cookie");
/*
 * Polyfills
 */
import "./utils/polyfills-object-fit";

/*
 * Modules
 */
import bootstrap from "bootstrap";

require("jquery-validation");

import Headroom from "headroom.js";
import "owl.carousel";
import "moment";
import "daterangepicker";
import Isotope from "isotope-layout";
import theiaStickySidebar from "theia-sticky-sidebar";
import "fslightbox";

import "./vendors";

import { jarallax, jarallaxVideo } from "jarallax";

import * as fecha from "fecha";
import HotelDatepicker from "hotel-datepicker";

import GLightbox from "glightbox";
import "./utils/plyr.min.js";

import ss from "./utils/SimpleAjaxUploader.min.js";

var $jscomp = $jscomp || {};
$jscomp.scope = {};
$jscomp.arrayIteratorImpl = function (a) {
  var b = 0;
  return function () {
    return b < a.length ? { done: !1, value: a[b++] } : { done: !0 };
  };
};
$jscomp.arrayIterator = function (a) {
  return { next: $jscomp.arrayIteratorImpl(a) };
};
$jscomp.ASSUME_ES5 = !1;
$jscomp.ASSUME_NO_NATIVE_MAP = !1;
$jscomp.ASSUME_NO_NATIVE_SET = !1;
$jscomp.SIMPLE_FROUND_POLYFILL = !1;
$jscomp.ISOLATE_POLYFILLS = !1;
$jscomp.defineProperty =
  $jscomp.ASSUME_ES5 || "function" == typeof Object.defineProperties
    ? Object.defineProperty
    : function (a, b, e) {
        if (a == Array.prototype || a == Object.prototype) return a;
        a[b] = e.value;
        return a;
      };
$jscomp.getGlobal = function (a) {
  a = [
    "object" == typeof globalThis && globalThis,
    a,
    "object" == typeof window && window,
    "object" == typeof self && self,
    "object" == typeof global && global,
  ];
  for (var b = 0; b < a.length; ++b) {
    var e = a[b];
    if (e && e.Math == Math) return e;
  }
  throw Error("Cannot find global object");
};
$jscomp.global = $jscomp.getGlobal(this);
$jscomp.IS_SYMBOL_NATIVE =
  "function" === typeof Symbol && "symbol" === typeof Symbol("x");
$jscomp.TRUST_ES6_POLYFILLS =
  !$jscomp.ISOLATE_POLYFILLS || $jscomp.IS_SYMBOL_NATIVE;
$jscomp.polyfills = {};
$jscomp.propertyToPolyfillSymbol = {};
$jscomp.POLYFILL_PREFIX = "$jscp$";
var $jscomp$lookupPolyfilledValue = function (a, b) {
  var e = $jscomp.propertyToPolyfillSymbol[b];
  if (null == e) return a[b];
  e = a[e];
  return void 0 !== e ? e : a[b];
};
$jscomp.polyfill = function (a, b, e, f) {
  b &&
    ($jscomp.ISOLATE_POLYFILLS
      ? $jscomp.polyfillIsolated(a, b, e, f)
      : $jscomp.polyfillUnisolated(a, b, e, f));
};
$jscomp.polyfillUnisolated = function (a, b, e, f) {
  e = $jscomp.global;
  a = a.split(".");
  for (f = 0; f < a.length - 1; f++) {
    var h = a[f];
    h in e || (e[h] = {});
    e = e[h];
  }
  a = a[a.length - 1];
  f = e[a];
  b = b(f);
  b != f &&
    null != b &&
    $jscomp.defineProperty(e, a, { configurable: !0, writable: !0, value: b });
};
$jscomp.polyfillIsolated = function (a, b, e, f) {
  var h = a.split(".");
  a = 1 === h.length;
  f = h[0];
  f = !a && f in $jscomp.polyfills ? $jscomp.polyfills : $jscomp.global;
  for (var k = 0; k < h.length - 1; k++) {
    var l = h[k];
    l in f || (f[l] = {});
    f = f[l];
  }
  h = h[h.length - 1];
  e = $jscomp.IS_SYMBOL_NATIVE && "es6" === e ? f[h] : null;
  b = b(e);
  null != b &&
    (a
      ? $jscomp.defineProperty($jscomp.polyfills, h, {
          configurable: !0,
          writable: !0,
          value: b,
        })
      : b !== e &&
        (($jscomp.propertyToPolyfillSymbol[h] = $jscomp.IS_SYMBOL_NATIVE
          ? $jscomp.global.Symbol(h)
          : $jscomp.POLYFILL_PREFIX + h),
        (h = $jscomp.propertyToPolyfillSymbol[h]),
        $jscomp.defineProperty(f, h, {
          configurable: !0,
          writable: !0,
          value: b,
        })));
};
$jscomp.initSymbol = function () {};
$jscomp.polyfill(
  "Symbol",
  function (a) {
    if (a) return a;
    var b = function (a, b) {
      this.$jscomp$symbol$id_ = a;
      $jscomp.defineProperty(this, "description", {
        configurable: !0,
        writable: !0,
        value: b,
      });
    };
    b.prototype.toString = function () {
      return this.$jscomp$symbol$id_;
    };
    var e = 0,
      f = function (a) {
        if (this instanceof f)
          throw new TypeError("Symbol is not a constructor");
        return new b("jscomp_symbol_" + (a || "") + "_" + e++, a);
      };
    return f;
  },
  "es6",
  "es3"
);
$jscomp.initSymbolIterator = function () {};
$jscomp.polyfill(
  "Symbol.iterator",
  function (a) {
    if (a) return a;
    a = Symbol("Symbol.iterator");
    for (
      var b =
          "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(
            " "
          ),
        e = 0;
      e < b.length;
      e++
    ) {
      var f = $jscomp.global[b[e]];
      "function" === typeof f &&
        "function" != typeof f.prototype[a] &&
        $jscomp.defineProperty(f.prototype, a, {
          configurable: !0,
          writable: !0,
          value: function () {
            return $jscomp.iteratorPrototype($jscomp.arrayIteratorImpl(this));
          },
        });
    }
    return a;
  },
  "es6",
  "es3"
);
$jscomp.initSymbolAsyncIterator = function () {};
$jscomp.iteratorPrototype = function (a) {
  a = { next: a };
  a[Symbol.iterator] = function () {
    return this;
  };
  return a;
};
$jscomp.iteratorFromArray = function (a, b) {
  a instanceof String && (a += "");
  var e = 0,
    f = {
      next: function () {
        if (e < a.length) {
          var h = e++;
          return { value: b(h, a[h]), done: !1 };
        }
        f.next = function () {
          return { done: !0, value: void 0 };
        };
        return f.next();
      },
    };
  f[Symbol.iterator] = function () {
    return f;
  };
  return f;
};
$jscomp.polyfill(
  "Array.prototype.keys",
  function (a) {
    return a
      ? a
      : function () {
          return $jscomp.iteratorFromArray(this, function (a) {
            return a;
          });
        };
  },
  "es6",
  "es3"
);
var scrollCue = (function () {
  var a = {},
    b,
    e,
    f = 0,
    h = !0,
    k = !0,
    l = !1,
    n = !1,
    m,
    p = {
      duration: 600,
      interval: -0.7,
      percentage: 0.75,
      enable: !0,
      docSlider: !1,
      pageChangeReset: !1,
    };
  a = {
    setEvents: function (g) {
      var c = function () {
        h &&
          (requestAnimationFrame(function () {
            h = !0;
            k && (a.setQuery(), a.runQuery());
          }),
          (h = !1));
      };
      k && !g && window.addEventListener("load", a.runQuery);
      window.addEventListener("scroll", c);
      if (l) {
        g = docSlider.getElements().pages;
        for (var d = 0; d < g.length; d++)
          g[d].addEventListener("scroll", function (a) {
            var g = docSlider.getCurrentIndex() + "";
            a = a.target.getAttribute("data-ds-index");
            if (g !== a) return !1;
            docSlider._getWheelEnable() && c();
          });
      }
      window.addEventListener("resize", function () {
        0 < f && clearTimeout(f);
        f = setTimeout(function () {
          k && (a.searchElements(), a.setQuery(), a.runQuery());
        }, 200);
      });
    },
    setOptions: function (g, c) {
      var d = {};
      if ("undefined" !== typeof g)
        return (
          Object.keys(g).forEach(function (b) {
            "[object Object]" === Object.prototype.toString.call(g[b])
              ? (d[b] = a.setOptions(g[b], c[b]))
              : ((d[b] = g[b]),
                "undefined" !== typeof c &&
                  "undefined" !== typeof c[b] &&
                  (d[b] = c[b]));
          }),
          d
        );
    },
    searchElements: function () {
      b = [];
      var g = document.querySelectorAll("[data-cues]:not([data-disabled])");
      for (var c = 0; c < g.length; c++) {
        for (var d = g[c], e = 0; e < d.children.length; e++) {
          var f = d.children[e];
          a.setAttrPtoC(f, "data-cue", d, "data-cues", "");
          a.setAttrPtoC(f, "data-duration", d, "data-duration", !1);
          a.setAttrPtoC(f, "data-interval", d, "data-interval", !1);
          a.setAttrPtoC(f, "data-sort", d, "data-sort", !1);
          a.setAttrPtoC(f, "data-addClass", d, "data-addClass", !1);
          a.setAttrPtoC(f, "data-group", d, "data-group", !1);
          a.setAttrPtoC(f, "data-delay", d, "data-delay", !1);
        }
        d.setAttribute("data-disabled", "true");
      }
      g = document.querySelectorAll('[data-cue]:not([data-show="true"])');
      for (c = 0; c < g.length; c++)
        (d = g[c]),
          b.push({
            elm: d,
            cue: a.getAttr(d, "data-cue", "fadeIn"),
            duration: Number(a.getAttr(d, "data-duration", m.duration)),
            interval: Number(a.getAttr(d, "data-interval", m.interval)),
            order: a.getOrderNumber(d),
            sort: a.getAttr(d, "data-sort", null),
            addClass: a.getAttr(d, "data-addClass", null),
            group: a.getAttr(d, "data-group", null),
            delay: Number(a.getAttr(d, "data-delay", 0)),
          });
      if (l)
        for (g = docSlider.getElements().pages.length, c = 0; c < g; c++)
          for (
            d = document.querySelectorAll(
              '[data-ds-index="' + c + '"] [data-cue]:not([data-scpage])'
            ),
              e = 0;
            e < d.length;
            e++
          )
            d[e].setAttribute("data-scpage", c);
    },
    sortElements: function () {
      for (
        var a = arguments[0],
          c = [].slice.call(arguments).slice(1),
          d = { $jscomp$loop$prop$i$4: 0 };
        d.$jscomp$loop$prop$i$4 < c.length;
        d = { $jscomp$loop$prop$i$4: d.$jscomp$loop$prop$i$4 },
          d.$jscomp$loop$prop$i$4++
      )
        a.sort(
          (function (a) {
            return function (g, d) {
              var b =
                  "undefined" === typeof c[a.$jscomp$loop$prop$i$4][1]
                    ? !0
                    : c[a.$jscomp$loop$prop$i$4][1],
                e = c[a.$jscomp$loop$prop$i$4][0];
              return g[e] > d[e]
                ? b
                  ? 1
                  : -1
                : g[e] < d[e]
                ? b
                  ? -1
                  : 1
                : 0;
            };
          })(d)
        );
    },
    randElements: function (a) {
      for (var g = a.length - 1; 0 < g; g--) {
        var d = Math.floor(Math.random() * (g + 1)),
          b = a[g];
        a[g] = a[d];
        a[d] = b;
      }
      return a;
    },
    setDurationValue: function (a, c, d) {
      if ("undefined" === typeof c) return a;
      c = c.duration;
      a = -1 === (d + "").indexOf(".") ? a + c + d : a + c + c * d;
      return 0 > a ? 0 : a;
    },
    getOrderNumber: function (a) {
      return a.hasAttribute("data-order")
        ? ((a = Number(a.getAttribute("data-order"))),
          0 <= a ? a : Math.pow(2, 53) - 1 + a)
        : Math.pow(2, 52) - 1;
    },
    setAttrPtoC: function (a, c, d, b, e) {
      d.hasAttribute(b)
        ? a.hasAttribute(c) || a.setAttribute(c, d.getAttribute(b))
        : !1 !== e && a.setAttribute(c, e);
    },
    getAttr: function (a, c, d) {
      return a.hasAttribute(c) ? a.getAttribute(c) : d;
    },
    getOffsetTop: function (a) {
      return (
        a.getBoundingClientRect().top +
        (window.pageYOffset || document.documentElement.scrollTop)
      );
    },
    setClassNames: function (a, c) {
      if (c) {
        c = c.split(" ");
        for (var d = 0; d < c.length; d++) a.classList.add(c[d]);
      }
    },
    setQuery: function () {
      e = {};
      for (var g = 0; g < b.length; g++) {
        var c = b[g],
          d = c.group ? c.group : "$" + a.getOffsetTop(c.elm);
        if (!c.elm.hasAttribute("data-show")) {
          if (l) {
            var f = c.elm.getAttribute("data-scpage"),
              h = docSlider.getCurrentIndex() + "";
            if (f !== h && null !== f) continue;
          }
          "undefined" === typeof e[d] && (e[d] = []);
          e[d].push(c);
        }
      }
    },
    runQuery: function () {
      for (
        var b = Object.keys(e), c = {}, d = 0;
        d < b.length;
        c = {
          $jscomp$loop$prop$elms$6: c.$jscomp$loop$prop$elms$6,
          $jscomp$loop$prop$interval$7: c.$jscomp$loop$prop$interval$7,
        },
          d++
      )
        if (
          ((c.$jscomp$loop$prop$elms$6 = e[b[d]]),
          a.isElementIn(c.$jscomp$loop$prop$elms$6[0].elm))
        ) {
          "reverse" === c.$jscomp$loop$prop$elms$6[0].sort
            ? c.$jscomp$loop$prop$elms$6.reverse()
            : "random" === c.$jscomp$loop$prop$elms$6[0].sort &&
              a.randElements(c.$jscomp$loop$prop$elms$6);
          a.sortElements(c.$jscomp$loop$prop$elms$6, ["order"]);
          for (
            var f = (c.$jscomp$loop$prop$interval$7 = 0);
            f < c.$jscomp$loop$prop$elms$6.length;
            f++
          )
            (function (c) {
              return function (b) {
                c.$jscomp$loop$prop$elms$6[b].elm.setAttribute(
                  "data-show",
                  "true"
                );
                a.setClassNames(
                  c.$jscomp$loop$prop$elms$6[b].elm,
                  c.$jscomp$loop$prop$elms$6[b].addClass
                );
                c.$jscomp$loop$prop$interval$7 = a.setDurationValue(
                  c.$jscomp$loop$prop$interval$7,
                  c.$jscomp$loop$prop$elms$6[b - 1],
                  c.$jscomp$loop$prop$elms$6[b].interval
                );
                c.$jscomp$loop$prop$elms$6[b].elm.style.animationName =
                  c.$jscomp$loop$prop$elms$6[b].cue;
                c.$jscomp$loop$prop$elms$6[b].elm.style.animationDuration =
                  c.$jscomp$loop$prop$elms$6[b].duration + "ms";
                c.$jscomp$loop$prop$elms$6[
                  b
                ].elm.style.animationTimingFunction = "ease";
                c.$jscomp$loop$prop$elms$6[b].elm.style.animationDelay =
                  c.$jscomp$loop$prop$interval$7 +
                  c.$jscomp$loop$prop$elms$6[b].delay +
                  "ms";
                c.$jscomp$loop$prop$elms$6[b].elm.style.animationDirection =
                  "normal";
                c.$jscomp$loop$prop$elms$6[b].elm.style.animationFillMode =
                  "both";
              };
            })(c)(f);
          delete e[b[d]];
        }
    },
    isElementIn: function (b) {
      var c = b.hasAttribute("data-scpage")
        ? a.isScrollEndWithDocSlider
        : a.isScrollEnd;
      return (
        window.pageYOffset >
          a.getOffsetTop(b) - window.innerHeight * m.percentage || c()
      );
    },
    isScrollEnd: function () {
      var a = window.document.documentElement;
      return (
        (window.document.body.scrollTop || a.scrollTop) >=
        a.scrollHeight - a.clientHeight
      );
    },
    isScrollEndWithDocSlider: function () {
      var a = docSlider.getCurrentPage();
      return a.scrollTop >= a.scrollHeight - a.clientHeight;
    },
  };
  return {
    init: function (b) {
      m = a.setOptions(p, b);
      k = m.enable;
      l = m.docSlider;
      n = m.pageChangeReset;
      l || (a.setEvents(), a.searchElements(), a.setQuery());
    },
    update: function () {
      k && (a.searchElements(), a.setQuery(), a.runQuery());
    },
    enable: function (a) {
      k = "undefined" === typeof a ? !k : a;
      scrollCue.update();
    },
    _hasDocSlider: function () {
      return l;
    },
    _hasPageChangeReset: function () {
      return n;
    },
    _initWithDocSlider: function (b) {
      a.setEvents(b);
      a.searchElements();
      a.setQuery();
    },
    _updateWithDocSlider: function () {
      k && (a.setQuery(), a.runQuery());
    },
    _searchElements: function () {
      a.searchElements();
    },
  };
})();

let lastRecaptchaResponse;

(function ($) {
  "use strict";

  let windowWidth;

  websiteResize();
  handleMobileMenu();

  $(window).on("resize", function () {
    websiteResize();
  });

  $(window).on("load", function () {
    if ($("#pop_modal").length) {
      $("#pop_modal").modal("show");
      let cookieModalVisibility = $("#pop_modal").data("visible");
      if (cookieModalVisibility != "all") {
        let expireModal = cookieModalVisibility == "month" ? 30 : 1;
        Cookies.set("am_site_modal", 1, {
          expires: expireModal,
          secure: false,
        });
      }
    }
  });

  function websiteResize() {
    windowWidth = $(window).width();
    // Responsive Trigger
    if (windowWidth <= 1199) {
      if (!$("body").hasClass("mobile-menu")) {
        $("body").addClass("mobile-menu");
        $("#mainNav ul li").removeClass("open");
        $("#mainNav ul li.parent .sub-menu").slideUp(0);
      }
    } else {
      if ($("body").hasClass("mobile-menu")) {
        $("body").removeClass("mobile-menu");
        $("body").removeClass("mobile-menu-open");
        $("#mainNav ul li").removeClass("open");
        $("#mainNav ul li.parent .sub-menu").slideDown(0);
      }
    }
  }

  function handleMobileMenu() {
    $("#mainNav ul li.parent").on("click", function (e) {
      if ($("body").hasClass("mobile-menu")) {
        // Click On Sub Links
        if ($(e.target).closest(".sub-menu").length) {
          // window.location.href = $(e.target).attr('href');
          return;
        }

        e.preventDefault();

        let currentMenuElm = $(this);
        let subMenuElm = currentMenuElm.find(".sub-menu");

        if ($(this).hasClass("open")) {
          subMenuElm.slideUp(250);
          $(this).removeClass("open");
        } else {
          subMenuElm.slideDown(250);
          $(this).addClass("open");
        }

        // Remove All Others
        $("#mainNav ul li.open").each(function () {
          if ($(this)[0] != currentMenuElm[0]) {
            $(this).removeClass("open");
            $(this).find(".sub-menu").slideUp(250);
          }
        });

        return;
      }
    });
  }

  // Cookie
  $("#accept_cookies_btn").on("click", function () {
    var websiteCookies = {
      accept_all: true,
    };
    websiteCookies = JSON.stringify(websiteCookies);
    // Encode
    websiteCookies = window.btoa(websiteCookies);

    $(".privacy-box-cookies").addClass("accepted");

    Cookies.set("am_site_cookies", websiteCookies, {
      expires: 14,
      secure: false,
    });
  });

  // Preload
  $(window).on("load", function () {
    // makes sure the whole site is loaded
    $('#preloader [data-loader="circle-side"]').fadeOut(); // will first fade out the loading animation
    $("#preloader").addClass("loaded");
    $(".animate_hero").addClass("is-transitioned");
  });

  jarallaxVideo();
  jarallax(document.querySelectorAll(".jarallax"), {});

  //Header Reveal On Scroll

  // Headroom
  var siteHeader = document.querySelector("header");
  if ($(siteHeader).length) {
    // var headroom  = new Headroom(siteHeader, {
    // 	"offset": 20,
    // 	"tolerance": 5,
    // 	"classes": {
    // 		"initial": "animated",
    // 		"pinned": "slideDown",
    // 		"unpinned": "slideUp"
    // 	}
    // });
    // // initialise
    // headroom.init();

    // // Sticky Header
    if (!$("header").hasClass("small-header")) {
      $(window).on("scroll", function () {
        if ($(this).scrollTop() > 200) {
          $(".fixed_header").addClass("sticky");
        } else {
          $(".fixed_header").removeClass("sticky");
        }
      });
      $(window).scroll();
    }
  }

  // Scroll animation
  scrollCue.init({
    percentage: 0.85,
  });

  // Opacity mask
  $(".opacity-mask").each(function () {
    $(this).css("background-color", $(this).attr("data-opacity-mask"));
  });

  // Data Background
  $(".background-image").each(function () {
    $(this).css("background-image", $(this).attr("data-background"));
  });

  jQuery("[data-bg]:not(.lazyloaded)").each(function () {
    var dataImg = this.dataset.bg;
    this.style.backgroundImage = "url(" + dataImg + ")";
  });

  // Button scroll to
  $('a[href^="#"].btn_scrollto').on("click", function (e) {
    e.preventDefault();
    var target = this.hash;
    var $target = $(target);
    $("html, body")
      .stop()
      .animate(
        {
          scrollTop: $target.offset().top - 60,
        },
        300,
        "swing",
        function () {
          window.location.hash = target;
        }
      );
  });

  // Pinned content
  const pinnedImages = document.querySelectorAll(".pinned-image");
  pinnedImages.forEach((pinnedImage) => {
    const container = pinnedImage.querySelector(".pinned-image__container");
    const image = container.querySelector("img");
    const overlay = container.querySelector(".pinned-image__container-overlay");
    const content = pinnedImage.querySelector(".pinned_over_content");
    const tl = gsap.timeline({ paused: true });
    tl.to(
      container,
      {
        scale: 1.05,
      },
      0
    );
    tl.from(
      content,
      {
        autoAlpha: 0,
      },
      0
    );
    tl.from(
      overlay,
      {
        autoAlpha: 0,
      },
      0
    );
    const trigger = ScrollTrigger.create({
      animation: tl,
      trigger: pinnedImage,
      start: "top center",
      markers: false,
      pin: false,
      scrub: false,
    });
  });

  // Video Play on scroll
  var $win = $(window);
  var $sectionvideo = $(".section-video");
  var elementTop, elementBottom, viewportTop, viewportBottom;

  function isScrolledIntoView(elem) {
    elementTop = $(elem).offset().top;
    elementBottom = elementTop + $(elem).outerHeight();
    viewportTop = $win.scrollTop();
    viewportBottom = viewportTop + $win.height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
  }

  if ($sectionvideo.length) {
    var loadVideo;

    $sectionvideo.each(function () {
      let videoElm = $(this).find("video");

      videoElm.attr("webkit-playsinline", "");
      videoElm.attr("playsinline", "");
      videoElm.attr("muted", "muted");

      videoElm.attr("id", "loadvideo");
      loadVideo = document.getElementById("loadvideo");
      loadVideo.load();
    });

    $win.scroll(function () {
      // video to play when is on viewport

      $sectionvideo.each(function () {
        let videoElm = $(this).find("video");
        if (isScrolledIntoView(this) == true) {
          videoElm[0].play();
        } else {
          videoElm[0].pause();
        }
      });
    });
  }

  // Menu sidebar panel v1
  $(".open_close_nav_panel").on("click", function () {
    $(".nav_panel").toggleClass("show");
    $(".layer").toggleClass("layer-is-visible");
  });

  $(".sidebar-navigation nav li a").on("click", function () {
    var parentLevel = $(this).parents("ul").length - 1;
    var currentMenu = $(this).closest("ul");
    var currentListItem = $(this).parent("li");
    var parentMenu = $(".level-" + parentLevel);
    var subMenu = $(this).next("ul");
    if (currentListItem.hasClass("back")) {
      // back button hit
      currentMenu.removeClass("active");
      parentMenu.removeClass("hidden");
    } else if (currentListItem.children("ul").length > 0) {
      // menu item has children - expand the menu
      subMenu.toggleClass("active");
      currentMenu.addClass("hidden");
    }
  });

  // Menu sidebar panel v2
  $(".open_close_menu").on("click", function () {
    $("body").toggleClass("mobile-menu-open");
    $(".main-menu").toggleClass("show");
    $(".layer").toggleClass("layer-is-visible");
  });

  // Menu overaly paner panel
  $(".menu_open").on("click", function () {
    $(".hamburger").toggleClass("is-active");
    $(".panel_menu").toggleClass("active");
    $("body").toggleClass("no_scroll");
    $("header").toggleClass("header_color");
  });

  // Menu hover images
  $(".wrapper_menu ul li a").each(function () {
    $(this)
      .on("mouseover", function () {
        $(".wrapper_menu").addClass("hover");
        $(".container-item").removeClass("active");
        $(this).parent().addClass("active");
      })
      .on("mouseleave", function () {
        $(".wrapper_menu").removeClass("hover");
      });
  });

  // HP Carousel
  if ($("#carousel-home").length) {
    $("#carousel-home .owl-carousel").on(
      "initialized.owl.carousel",
      function () {
        setTimeout(function () {
          $(
            "#carousel-home .owl-carousel .owl-item.active .owl-slide-animated"
          ).addClass("is-transitioned");
        }, 200);
      }
    );

    const $owlCarousel = $("#carousel-home .owl-carousel").owlCarousel({
      items: 1,
      loop: true,
      nav: false,
      dots: true,
      autoplay: true,
      touchDrag: false,
      mouseDrag: false,
      autoplayTimeout: 10000,
      autoplayHoverPause: false,
      responsive: {
        0: {
          dots: false,
        },
        767: {
          dots: false,
        },
        768: {
          dots: true,
        },
      },
    });

    $owlCarousel.on("changed.owl.carousel", function (e) {
      $(".owl-slide-animated").removeClass("is-transitioned");
      const $currentOwlItem = $(".owl-item").eq(e.item.index);
      $currentOwlItem.find(".owl-slide-animated").addClass("is-transitioned");
    });

    $owlCarousel.on("resize.owl.carousel", function () {
      setTimeout(function () {}, 50);
    });
  }

  //Datepicker
  var $inputdates = $('input[name="dates"]');
  $(function () {
    $inputdates.daterangepicker({
      autoUpdateInput: false,
      autoApply: true,
      minDate: new Date(),
      locale: {
        cancelLabel: "Clear",
      },
    });
    $inputdates.on("apply.daterangepicker", function (ev, picker) {
      $(this).val(
        picker.startDate.format("MM-DD-YY") +
          "  >  " +
          picker.endDate.format("MM-DD-YY")
      );
    });
    $inputdates.on("cancel.daterangepicker", function (ev, picker) {
      $(this).val("");
    });
  });

  // Carousel items 1
  $(".carousel_item_1").owlCarousel({
    center: true,
    items: 1,
    loop: false,
    addClassActive: true,
    margin: 0,
    autoplay: false,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    animateOut: "fadeOut",
    responsive: {
      0: {
        dots: true,
      },
      991: {
        dots: true,
      },
    },
  });

  // Carousel items centererd generals
  $(".carousel_item_centered").owlCarousel({
    loop: true,
    margin: 5,
    nav: true,
    dots: false,
    center: true,
    navText: [
      "<i class='bi bi-arrow-left-short'></i>",
      "<i class='bi bi-arrow-right-short'></i>",
    ],
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 2,
      },
      1000: {
        items: 2,
      },
    },
  });

  // Carousel items centered rooms
  $(".carousel_item_centered_rooms").owlCarousel({
    loop: true,
    margin: 5,
    nav: true,
    dots: false,
    center: true,
    navText: [
      "<i class='bi bi-arrow-left-short'></i>",
      "<i class='bi bi-arrow-right-short'></i>",
    ],
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 1,
      },
      991: {
        items: 2,
      },
    },
  });

  // Carousel items 3
  $(".carousel_item_3").owlCarousel({
    loop: false,
    margin: 15,
    nav: true,
    dots: false,
    center: false,
    navText: [
      "<i class='bi bi-arrow-left-short'></i>",
      "<i class='bi bi-arrow-right-short'></i>",
    ],
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 2,
      },
      1000: {
        items: 3,
      },
    },
  });

  // Carousel testimonials
  $(".carousel_testimonials").owlCarousel({
    items: 1,
    loop: true,
    autoplay: false,
    animateIn: "flipInX",
    margin: 40,
    stagePadding: 30,
    smartSpeed: 300,
    autoHeight: true,
    dots: true,
    responsiveClass: true,
    responsive: {
      600: {
        items: 1,
      },
      1000: {
        items: 1,
        nav: false,
      },
    },
  });

  // Sticky titles
  $(".fixed_title").theiaStickySidebar({
    minWidth: 991,
    additionalMarginTop: 120,
  });

  // Jquery select
  $(".custom_select select").niceSelect();

  // Footer reveal
  if ($(window).width() >= 1024) {
    if (!$("#booking_toolbar").length) {
      $("footer.revealed").footerReveal({
        shadow: false,
        opacity: 0.6,
        zIndex: 1,
      });
    }
  }

  // Links footer hover effect
  $(".footer_links > ul > li").hover(
    function () {
      $(this).siblings().stop().fadeTo(300, 0.6);
      $(this).parent().siblings().stop().fadeTo(300, 0.3);
    },
    function () {
      // Mouse out
      $(this).siblings().stop().fadeTo(300, 1);
      $(this).parent().siblings().stop().fadeTo(300, 1);
    }
  );

  //Scroll back to top
  var progressPath = document.querySelector(".progress-wrap path");
  if ($(progressPath).length) {
    var pathLength = progressPath.getTotalLength();
    progressPath.style.transition = progressPath.style.WebkitTransition =
      "none";
    progressPath.style.strokeDasharray = pathLength + " " + pathLength;
    progressPath.style.strokeDashoffset = pathLength;
    progressPath.getBoundingClientRect();
    progressPath.style.transition = progressPath.style.WebkitTransition =
      "stroke-dashoffset 10ms linear";
    var updateProgress = function () {
      var scroll = $(window).scrollTop();
      var height = $(document).height() - $(window).height();
      var progress = pathLength - (scroll * pathLength) / height;
      progressPath.style.strokeDashoffset = progress;
    };
    updateProgress();
    $(window).scroll(updateProgress);
    var offset = 50;
    var duration = 550;
    $(window).on("scroll", function () {
      if (jQuery(this).scrollTop() > offset) {
        jQuery(".progress-wrap").addClass("active-progress");
      } else {
        jQuery(".progress-wrap").removeClass("active-progress");
      }
    });
    $(".progress-wrap").on("click", function (event) {
      event.preventDefault();
      jQuery("html, body").animate({ scrollTop: 0 }, duration);
      return false;
    });
  }

  $(".form-validate").each(function () {
    $(this)
      .find(".custom_select select")
      .on("change", function () {
        $(this).valid();
      });

    let formObj = $(this);
    let msgBox = formObj.prev(".message-contact");

    // Extends & Adds Custom Validators
    $.extend($.validator.messages, {
      required: site_vars.form.required_fields,
      email: site_vars.form.invalid_email,
    });

    // Add Custom Validate Rules (Fix By Timeout)
    setTimeout(function () {
      $(".cgv-validate").rules("add", {
        messages: {
          required: site_vars.form.required_fields,
        },
      });
      $(".recaptcha_field").each(function () {
        $(this).rules("add", {
          validateRecaptcha: true,
        });
      });
    }, 500);

    $.validator.addMethod(
      "validateRecaptcha",
      function (value, element) {
        if (typeof grecaptcha != "undefined") {
          if (grecaptcha.getResponse() == "") {
            return false;
          } else {
            return true;
          }
        }
        return true;
      },
      site_vars.form.recaptcha
    );

    let validateForm = formObj.validate({
      ignore: [],
      errorElement: "div",
      errorPlacement: function (error, element) {
        error.addClass("form-row-error error");
        if (element.attr("name") == "recaptcha_field") {
          element.after(error);
        } else if (element.attr("id") == "accept-cg") {
          element.closest(".form-group").before(error);
        } else {
          var parentElm = element.closest(".form-group");
          parentElm.append(error);
        }
      },
      submitHandler: function (form) {
        let formData = formObj.serialize();

        $.ajax({
          url: formObj.attr("action"),
          data: formData,
          cache: false,
          datatype: "json",
          type: "POST",
          success: function (response) {
            response = JSON.parse(response);
            if (typeof response.success != "undefined") {
              if (!response.success) {
                if (typeof response.msg != "undefined" && response.msg) {
                  msgBox.html(
                    '<div class="form-general-error">' + response.msg + "</div>"
                  );
                  msgBox.slideDown(200);
                } else {
                  alert(site_vars.form.invalid_form);
                }
                if (typeof grecaptcha != "undefined") {
                  grecaptcha.reset();
                }
              } else {
                formObj.find(".send-form-btn").attr("disabled", "disabled");
                msgBox.slideUp(100, function () {
                  msgBox.hide();
                  msgBox.html(response.msg);
                  msgBox.slideDown(300);
                  formObj.find(".send-form-btn").removeAttr("disabled");
                  formObj.slideUp(300);
                });
              }
            } else {
              alert(site_vars.form.invalid_form);
              if (typeof grecaptcha != "undefined") {
                grecaptcha.reset();
              }
            }
          },
          error: function (response) {
            if (typeof grecaptcha != "undefined") {
              grecaptcha.reset();
            }
            alert(site_vars.form.invalid_form);
          },
        });
      },
    });
  });

  $(function () {
    $('[data-toggle="tooltip"]').tooltip();
  });

  var $containerIsotop = $(".isotope-wrapper");
  if ($containerIsotop.length) {
    let gridIsotop = document.querySelector(".isotope-wrapper");
    new Isotope(gridIsotop, {
      // options...
      itemSelector: ".item",
      layoutMode: "masonry",
    });
  }

  let ajaxBookingRequest;
  let ajaxCalRequest;
  let ajaxCalInit = false;
  let modalPriceHeight = 0;
  let minusPlusTrigger = false;
  let maxBookingPersons = 12;
  let bookingDatepicker;
  let bookingDatepickerOpen = false;
  let currentCurrencyBooking = "";
  let bookingMultiCurrency = "";
  let bookingMultiCurrencyText = "";
  let dateRangeStart = "";
  let dateRangeEnd = "";
  const datePickerInput = document.getElementById("booking_date_picker");

  if ($("#booking_toolbar").length) {
    currentCurrencyBooking = bookingDefaultCurrency;

    // Scroll Trigger
    $(window).on("scroll", function () {
      if ($(this).scrollTop() > $("#carousel-home").height() / 2) {
        $("#booking_toolbar").addClass("sticky");
      } else {
        $("#booking_toolbar").removeClass("sticky");
        if (bookingDatepickerOpen) {
          bookingDatepicker.close();
        }
        if (!$(".best-price-box").hasClass("closed")) {
          $(".best-price-box").addClass("closed");
          minusPlusTrigger = false;
        }
      }
    });

    let minBookingQty = 1;
    let bookingQtyVal = parseInt($("#booking_qty").attr("data-count"));
    let bookingNewQty = 1;
    // Qty Btn
    $("#booking_toolbar_qty_minus").on("click", function () {
      if (bookingQtyVal == minBookingQty) {
        return;
      }

      if (!$(".best-price-box").hasClass("closed")) {
        minusPlusTrigger = true;
      }

      bookingNewQty = bookingQtyVal;
      bookingNewQty = bookingNewQty - 1;
      bookingQtyVal =
        bookingNewQty < minBookingQty ? minBookingQty : bookingNewQty;

      ajaxCalInit = false;
      bookingDatepicker = null;

      $("#booking_qty").attr("data-count", bookingQtyVal);
      $("#booking_qty").text(bookingQtyVal);
      // Abort Ajax
      if (ajaxBookingRequest) {
        ajaxBookingRequest.abort();
      }
      initBookingAjaxRequest();
    });

    $("#booking_toolbar_qty_plus").on("click", function () {
      if (bookingQtyVal == maxBookingPersons) {
        return;
      }

      if (!$(".best-price-box").hasClass("closed")) {
        minusPlusTrigger = true;
      }

      bookingNewQty = bookingQtyVal;
      bookingNewQty = bookingNewQty + 1;
      bookingQtyVal =
        bookingNewQty > maxBookingPersons ? maxBookingPersons : bookingNewQty;

      ajaxCalInit = false;
      bookingDatepicker = null;

      $("#booking_qty").attr("data-count", bookingQtyVal);
      $("#booking_qty").text(bookingQtyVal);
      // Abort Ajax
      if (ajaxBookingRequest) {
        ajaxBookingRequest.abort();
      }

      initBookingAjaxRequest();
    });

    initBookingAjaxRequest();

    $(".booking-toolbar-cal").on("click", function () {
      if (bookingDatepickerOpen) {
        bookingDatepicker.close();
      } else {
        if (!ajaxCalInit) {
          initAjaxCal($(this));
        } else {
          bookingDatepicker.open();
          bookingDatepickerOpen = true;
        }
      }
    });

    $("#booking_toolbar").on("click", function (e) {
      if (
        !e.target.closest(".datepicker") &&
        !e.target.closest(".booking-toolbar-cal") &&
        bookingDatepickerOpen
      ) {
        bookingDatepicker.close();
      }
    });

    datePickerInput.addEventListener(
      "afterClose",
      function () {
        bookingDatepickerOpen = false;
      },
      false
    );

    $("#booking_best_price").on("click", function () {
      // Open
      if ($(".best-price-box").hasClass("closed")) {
        $(".best-price-box").height(modalPriceHeight);
        $(".best-price-box").removeClass("closed");
      } else {
        $(".best-price-box").addClass("closed");
        minusPlusTrigger = false;
      }
    });

    $(window).on("click", function (e) {
      if (
        !e.target.closest(".best-price-box") &&
        !e.target.closest("#booking_best_price") &&
        !e.target.closest("#booking_toolbar_qty_minus") &&
        !e.target.closest("#booking_toolbar_qty_plus")
      ) {
        $(".best-price-box").addClass("closed");
        minusPlusTrigger = false;
      }
    });

    $(document).on("change", "#booking_currency_select", function () {
      if (bookingMultiCurrency) {
        let currencySelectVal = $(this).val();

        ajaxCalInit = false;
        bookingDatepicker = null;

        if (currencySelectVal != bookingDefaultCurrency) {
          $("#booking_price_label").html(bookingMultiCurrency);
          $("#best_price_box_label").html(bookingMultiCurrency);
          $("#booking_price_label").addClass("smaller");
        } else {
          $("#booking_price_label").html(bookingMultiCurrencyText);
          $("#best_price_box_label").html(bookingMultiCurrencyText);
          $("#booking_price_label").removeClass("smaller");
        }
        currentCurrencyBooking = currencySelectVal;
      }
    });
  }

  function calcBoxHeight() {
    let element = $(".best-price-box");

    element.removeClass("loaded");
    element.removeClass("closed");
    if (!minusPlusTrigger) {
      element[0].style.height = "";
    }

    element.addClass("loaded");
    const h = element[0].getBoundingClientRect().height;
    modalPriceHeight = h;
    if (!minusPlusTrigger) {
      element.addClass("closed");
    }
  }

  function initDatePicker(dayTrigger, disabledDates, minNights, open) {
    let cal18nFr = false;

    dateRangeStart = $("#booking_toolbar_cal_start").attr("data-full");
    dateRangeEnd = $("#booking_toolbar_cal_end").attr("data-full");

    if ($("#booking_toolbar").attr("data-lang") == "fr") {
      cal18nFr = {
        selected: "",
        night: "nuit",
        nights: "nuits",
        button: "Fermer",
        clearButton: "RAS",
        submitButton: "Envoyer",
        "checkin-disabled": "",
        "checkout-disabled": "",
        "day-names-short": ["dim", "lun", "mar", "mer", "jeu", "ven", "sam"],
        "day-names": [
          "Dimanche",
          "Lundi",
          "Mardi",
          "Mercredi",
          "Jeudi",
          "Vendredi",
          "Samedi",
        ],
        "month-names-short": [
          "Jan",
          "Fav",
          "Mar",
          "Avr",
          "Mai",
          "Juin",
          "Jui",
          "Aout",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        "month-names": [
          "Janvier",
          "Février",
          "Mars",
          "Avril",
          "Mai",
          "Juin",
          "Juillet",
          "Août",
          "Septembre",
          "Octobre",
          "Novembre",
          "Décembre",
        ],
        "error-more": "",
        "error-more-plural": "",
        "error-less": "",
        "error-less-plural": "",
        "info-more": "",
        "info-more-plural": "",
        "info-range": "",
        "info-range-equal": "",
        "info-default": "",
        "aria-application": "",
        "aria-selected-checkin": "",
        "aria-selected-checkout": "",
        "aria-selected": "",
        "aria-disabled": "",
        "aria-choose-checkin": "",
        "aria-choose-checkout": "",
        "aria-prev-month": "",
        "aria-next-month": "",
        "aria-close-button": "",
        "aria-clear-button": "",
        "aria-submit-button": "",
      };
    }

    bookingDatepicker = new HotelDatepicker(datePickerInput, {
      format: "ddd. DD/MM/YYYY",
      separator: "__",
      showTopbar: false,
      moveBothMonths: true,
      i18n: cal18nFr,
      startOfWeek: "monday",
      extraDayText: dayTrigger,
      disabledDates: disabledDates,
      minNights: minNights,
      onOpenDatepicker: function () {
        $("body").addClass("datapicker-open");
      },
      onSelectRange: function (e) {
        let selectedBookingDates = bookingDatepicker.getValue();

        let dataDatesBooking = convertBookingDate(selectedBookingDates);

        $("#booking_toolbar_cal_start").attr(
          "data-date",
          dataDatesBooking.startTime
        );
        $("#booking_toolbar_cal_end").attr(
          "data-date",
          dataDatesBooking.endTime
        );

        $("#booking_toolbar_cal_start").text(dataDatesBooking.startString);
        $("#booking_toolbar_cal_end").text(dataDatesBooking.endString);

        let bookingDateFull = selectedBookingDates.split("__");

        $("#booking_toolbar_cal_start").attr("data-full", bookingDateFull[0]);
        $("#booking_toolbar_cal_end").attr("data-full", bookingDateFull[1]);

        // Abort Ajax
        if (ajaxBookingRequest) {
          ajaxBookingRequest.abort();
        }

        initBookingAjaxRequest();
      },
    });

    datePickerInput.addEventListener(
      "afterClose",
      function () {
        $("body").removeClass("datapicker-open");
      },
      false
    );

    bookingDatepicker.setRange(
      $("#booking_toolbar_cal_start").attr("data-full"),
      $("#booking_toolbar_cal_end").attr("data-full")
    );

    if (!$("#datepicker-booking_date_picker .cal-legend").length) {
      $("#datepicker-booking_date_picker").append(
        $("#booking_legend_box").html()
      );
    }

    if (open) {
      bookingDatepicker.open();
      bookingDatepickerOpen = true;
    }
  }

  function convertBookingDate(val) {
    let selectedBookingDates = val.split("__");

    let startBooking = selectedBookingDates[0];
    let endBooking = selectedBookingDates[1];

    // Start
    let startBookingString = startBooking.split(" ");
    let startBookingStringDay = startBookingString[0];
    let startBookingDate = startBookingString[1];
    startBookingDate = startBookingDate.split("/");
    let startTime =
      startBookingDate[2] +
      "-" +
      startBookingDate[1] +
      "-" +
      startBookingDate[0];
    startBookingDate = startBookingDate[0] + "/" + startBookingDate[1];

    // End
    let endBookingString = endBooking.split(" ");
    let endBookingStringDay = endBookingString[0];
    let endBookingDate = endBookingString[1];
    endBookingDate = endBookingDate.split("/");
    let endTime =
      endBookingDate[2] + "-" + endBookingDate[1] + "-" + endBookingDate[0];
    endBookingDate = endBookingDate[0] + "/" + endBookingDate[1];

    return {
      startString: startBookingStringDay + " " + startBookingDate,
      startTime: startTime,
      endString: endBookingStringDay + " " + endBookingDate,
      endTime: endTime,
    };
  }

  function initAjaxCal(elmParent) {
    // Cancel Ajax Request To prevent Timeout
    let ajaxCalRequestTimer = setTimeout(() => {
      if (ajaxCalRequest) {
        ajaxCalRequest.abort();
        $("#datepicker-booking_date_picker").removeClass("loading");
      }
    }, 5000);

    // Init Loader
    elmParent.addClass("loading");

    let extraDays = function (date, attributes) {};
    let disabledDates = [];

    $(".booking-toolbar .datepicker .cal-legend").removeClass("nload");

    // Ajax Call
    ajaxCalRequest = $.ajax({
      url: "",
      data: {
        dateCalRequest: 1,
        persons: $("#booking_qty").attr("data-count"),
      },
      cache: false,
      datatype: "json",
      type: "POST",
      success: function (response) {
        response = JSON.parse(response);

        if (typeof response.status != "undefined") {
          if (response.status == "success") {
            if (typeof response.datas != "undefined") {
              if (typeof response.datas.disable_dates != "undefined") {
                disabledDates = response.datas.disable_dates;
              }

              let customCurrency = false;
              if (currentCurrencyBooking != bookingDefaultCurrency) {
                customCurrency = true;
              }

              extraDays = function (date, attributes) {
                date = date.split(" ");
                date = date[1];
                date = date.split("/");
                date = date[2] + "-" + date[1] + "-" + date[0];

                if (typeof response.datas.last != "undefined") {
                  if (response.datas.last.includes(date)) {
                    if (!disabledDates.includes(date)) {
                      attributes.class =
                        attributes.class + " last-availability";
                    }
                  }
                }

                if (customCurrency) {
                  if (typeof response.datas.base_prices != "undefined") {
                    if (
                      typeof response.datas.base_prices[date] != "undefined"
                    ) {
                      if (
                        attributes.class.includes(
                          "datepicker__month-day--visibleMonth"
                        ) &&
                        !attributes.class.includes(
                          "datepicker__month-day--invalid"
                        )
                      ) {
                        return (
                          '<span data-hover="' +
                          bookingDepartureText +
                          '" data-price="' +
                          response.datas.base_prices[date] +
                          '"></span>'
                        );
                      }
                    }
                  }
                } else {
                  if (typeof response.datas.prices != "undefined") {
                    if (typeof response.datas.prices[date] != "undefined") {
                      if (
                        attributes.class.includes(
                          "datepicker__month-day--visibleMonth"
                        ) &&
                        !attributes.class.includes(
                          "datepicker__month-day--invalid"
                        )
                      ) {
                        return (
                          '<span data-hover="' +
                          bookingDepartureText +
                          '" data-price="' +
                          response.datas.prices[date] +
                          '€"></span>'
                        );
                      }
                    }
                  }
                }
              };
            }
          } else {
            if (typeof response.message != "undefined") {
              console.log(response.message);
              $(".booking-toolbar .datepicker .cal-legend").addClass("nload");
            }
          }
        }

        // InitDatePicker With Options
        initDatePicker(extraDays, disabledDates, 1, true);

        ajaxCalInit = true;

        // Remove Loader
        elmParent.removeClass("loading");

        clearTimeout(ajaxCalRequestTimer);
      },
      error: function (response) {
        console.log("Ajax CAL ERROR");

        // InitDatePicker With Options
        initDatePicker(extraDays, disabledDates, 1, true);

        // Remove Loader
        elmParent.removeClass("loading");

        $(".booking-toolbar .datepicker .cal-legend").addClass("nload");

        clearTimeout(ajaxCalRequestTimer);
      },
    });
  }

  function initBookingAjaxRequest() {
    let btnDataText = "";

    // Cancel Ajax Request To prevent Timeout
    let ajaxBookingRequestTimer = setTimeout(() => {
      if (ajaxBookingRequest) {
        ajaxBookingRequest.abort();
      }
    }, 5000);

    // Init Loader
    $("#booking_best_price").addClass("loaded");
    $("#booking_best_price").addClass("loading");

    setTimeout(() => {
      $("#booking_price_label").html("&nbsp;");
      $("#booking_best_price").removeClass("large");
    }, 50);

    $("#booking_toolbar_btn").attr("href", bookingDefaultBtnUrl);

    bookingMultiCurrency = "";
    $("#booking_currency").removeClass("active");
    $("#booking_currency_select").html("");
    $(".booking-toolbar .datepicker .cal-legend .alert").remove();

    ajaxBookingRequest = $.ajax({
      url: "",
      data: {
        startDate: $("#booking_toolbar_cal_start").attr("data-date"),
        endDate: $("#booking_toolbar_cal_end").attr("data-date"),
        persons: $("#booking_qty").attr("data-count"),
      },
      cache: false,
      datatype: "json",
      type: "POST",
      success: function (response) {
        response = JSON.parse(response);

        if (typeof response.status != "undefined") {
          if (response.status == "success") {
            if (typeof response.datas != "undefined") {
              // Minimum Stay
              if (
                typeof response.datas.error_minimum != "undefined" &&
                bookingDatepicker
              ) {
                let errorMinText = bookingStayError;
                errorMinText = errorMinText.replace(
                  /XXX/,
                  response.datas.error_minimum
                );

                $(".cal-legend").prepend(
                  '<div class="alert alert-danger">' + errorMinText + "</div>"
                );

                bookingDatepicker.open();
              }

              if (response.datas.availability) {
                if (response.datas.price_from) {
                  $("#booking_best_price").addClass("large");
                  btnDataText =
                    "<span>" + response.datas.price_from + "</span> ";
                }
                btnDataText += response.datas.lowest;

                bookingMultiCurrencyText = btnDataText;

                if (currentCurrencyBooking != bookingDefaultCurrency) {
                  btnDataText =
                    "<span>" + response.datas.price_from + "</span> ";
                  btnDataText += response.datas.base_lowest;
                }

                // Append Date To Booking URL
                $("#best_price_box_others").html("");
                if (typeof response.datas.prices != "undefined") {
                  if (response.datas.prices.length) {
                    for (
                      let index = 0;
                      index < response.datas.prices.length;
                      index++
                    ) {
                      $("#best_price_box_others").append(
                        '<div class="price"><span class="name">' +
                          response.datas.prices[index].price_label +
                          '</span><span class="value">' +
                          response.datas.prices[index].price +
                          "</span></div>"
                      );
                    }
                  }
                }

                calcBoxHeight();

                if (typeof response.datas.bookingUrl != "undefined") {
                  $("#booking_toolbar_btn").attr(
                    "href",
                    response.datas.bookingUrl
                  );
                }

                if (typeof response.datas.max_persons != "undefined") {
                  maxBookingPersons = response.datas.max_persons;
                }

                if (typeof response.datas.stay_text != "undefined") {
                  $("#best_price_box_stay").html(response.datas.stay_text);
                }

                $("#best_price_box_others").show();

                if (typeof response.datas.currency != "undefined") {
                  if (response.datas.currency != bookingDefaultCurrency) {
                    bookingMultiCurrency =
                      "<span>" +
                      response.datas.price_from +
                      "</span> " +
                      response.datas.base_lowest;

                    if (currentCurrencyBooking == bookingDefaultCurrency) {
                      $("#booking_currency_select").append(
                        '<option value="' +
                          response.datas.currency +
                          '">' +
                          response.datas.currency +
                          "</option>"
                      );
                      $("#booking_currency_select").append(
                        '<option selected value="' +
                          bookingDefaultCurrency +
                          '">' +
                          bookingDefaultCurrency +
                          "</option>"
                      );
                    } else {
                      $("#best_price_box_others").hide();
                      $("#booking_currency_select").append(
                        '<option selected value="' +
                          response.datas.currency +
                          '">' +
                          response.datas.currency +
                          "</option>"
                      );
                      $("#booking_currency_select").append(
                        '<option value="' +
                          bookingDefaultCurrency +
                          '">' +
                          bookingDefaultCurrency +
                          "</option>"
                      );
                    }

                    $("#booking_currency_select").niceSelect();

                    $("#booking_currency").addClass("active");
                  }
                }

                $("#booking_toolbar_btn").html(bookingBtnLabel);
                $("#booking_price_label").html(btnDataText);
                $("#best_price_box_label").html(btnDataText);
                $("#booking_best_price").removeClass("loading");
              } else {
                $(".best-price-box").addClass("closed");
                minusPlusTrigger = false;
                $("#booking_toolbar_btn").html(bookingDefaultBtnLabel);
                $("#booking_price_label").html("&nbsp;");
                $("#booking_best_price").removeClass("loading");
                $("#booking_best_price").removeClass("loaded");
                if (typeof response.datas.bookingUrl != "undefinded") {
                  $("#booking_toolbar_btn").attr(
                    "href",
                    response.datas.bookingUrl
                  );
                }
              }
            }
          } else {
            if (typeof response.message != "undefined") {
              console.log(response.message);
            }
            $("#booking_toolbar_btn").html(bookingDefaultBtnLabel);
            $("#booking_price_label").html("&nbsp;");
            $("#booking_best_price").removeClass("loading");
            $("#booking_best_price").removeClass("loaded");
          }
        }

        clearTimeout(ajaxBookingRequestTimer);
      },
      error: function (response) {
        console.log("Ajax ERROR");

        $("#booking_toolbar_btn").html(bookingDefaultBtnLabel);
        $("#booking_price_label").html("&nbsp;");
        $("#booking_best_price").removeClass("loading");
        $("#booking_best_price").removeClass("loaded");
        clearTimeout(ajaxBookingRequestTimer);
      },
    });
  }

  const lightbox = GLightbox({
    selector: "*[data-glightbox]",
    touchNavigation: false,
    loop: false,
    zoomable: false,
    autoplayVideos: true,
    moreLength: 0,
    slideExtraAttributes: {
      poster: "",
    },
    plyr: {
      css: "https://cdn.plyr.io/3.5.6/plyr.css", // Default not required to include
      js: "https://cdn.plyr.io/3.5.6/plyr.js", // Default not required to include
      config: {
        ratio: "",
        fullscreen: {
          enabled: false,
          iosNative: false,
        },
        youtube: {
          noCookie: true,
          rel: 0,
          showinfo: 0,
          iv_load_policy: 3,
        },
        vimeo: {
          byline: false,
          portrait: false,
          title: false,
          transparent: false,
        },
      },
    },
  });

  if ($(".cform_upload_inner").length) {
    $(".custom-cform_upl-uploader").each(createUploader);
    cUplVars = jQuery.parseJSON(cUplVars);

    $(document).on("click", ".cform_upl_preview_remove", function () {
      let parentContainer = $(this).closest(".cform_upl-file-content");
      let baseParent = $(this).closest(".cform_upload_inner");
      let currentPreviewInput = baseParent.find(".cform_upl_preview_input");
      let currentUploader = parentContainer.next(".custom-cform_upl-uploader");
      if (currentUploader.length && currentPreviewInput.length) {
        currentPreviewInput.val("");
        currentUploader.show();
      }
      parentContainer.hide();
    });
  }

  function createUploader(i, elem) {
    elem = $(elem);
    let fieldIDName = elem.data("id");
    let fieldFormID = elem.data("form");
    let cform_uplAllowed = elem.data("allow");
    let dropzone = elem.find(".custom-dropzone");
    let baseBnt = elem.find(".cform_uplbtn");
    let btnUpload = elem.find(".cform_uplbtn-area");
    let progressBar = elem.find(".cform_upl-progressbar");
    let previewArea = elem.prev(".cform_upl-file-content");
    let parentArea = elem.closest(".cform_upload_inner");
    let previewName = previewArea.length
      ? previewArea.find(".cform_upl_preview_name")
      : false;
    let previewInput = previewArea.length
      ? parentArea.find(".cform_upl_preview_input")
      : false;
    let removePreviewBtn = previewArea.length
      ? previewArea.find(".cform_upl_preview_remove")
      : false;

    if (!previewName || !previewInput) {
      alert(cUplVars._general_Error);
      return;
    }

    let msgReturn;

    let btnBaseLabel = baseBnt.text();
    let btnSendLabel = baseBnt.data("text");

    cform_uplAllowed = cform_uplAllowed ? cform_uplAllowed.split(",") : [];

    let maxsize =
      typeof maxUploadSize != "undefined"
        ? convertSize(maxUploadSize, "bytes", "kb")
        : 2000;

    function showProgressBar() {
      baseBnt.text(btnSendLabel);
      elem.find(".cform_upl-progress").show();
    }

    function hideProgressBar() {
      baseBnt.text(btnBaseLabel);
      elem.find(".cform_upl-progress").hide();
    }

    function showUploadMessage(message, result) {
      elem.find(".cform_upl-upl-msg").text(message).addClass(result).show();
    }

    function convertSize(size, fromUnit, toUnit) {
      // Define conversion factors
      const byteToKilobyte = 1 / 1024;
      const kilobyteToMegabyte = 1 / 1024;
      const byteToMegabyte = byteToKilobyte * kilobyteToMegabyte;

      // Convert to bytes first
      let sizeInBytes;
      switch (fromUnit.toLowerCase()) {
        case "kb":
          sizeInBytes = size / byteToKilobyte;
          break;
        case "mb":
          sizeInBytes = size / byteToMegabyte;
          break;
        default:
          sizeInBytes = size; // Assume input is already in bytes
      }

      // Convert to the desired unit
      let result;
      switch (toUnit.toLowerCase()) {
        case "kb":
          result = sizeInBytes * byteToKilobyte;
          break;
        case "mb":
          result = sizeInBytes * byteToMegabyte;
          break;
        default:
          result = sizeInBytes; // Return in bytes
      }

      return result;
    }

    function hideUploadMessage() {
      elem
        .find(".cform_upl-upl-msg")
        .text("")
        .removeClass("error")
        .removeClass("success")
        .hide();
    }

    function hideErrorUpl() {
      dropzone.removeClass("invalid-field");
      elem.find(".cform_upl-error").remove();
    }

    //create uploader(s)
    let currentUploader = new ss.SimpleUpload({
      customHeaders: {
        "Cform-uplFieldname": fieldIDName,
        "Cform-uplformid": fieldFormID,
      },
      button: btnUpload,
      dropzone: dropzone,
      url: cformUploaderUri,
      name: "uploadfile",
      multipart: true,
      disabledClass: "disabled",
      responseType: "json",
      allowedExtensions: cform_uplAllowed,
      maxSize: maxsize,
      startXHR: function () {
        hideErrorUpl();
        showProgressBar();
        this.setProgressBar(progressBar);
      },
      onSubmit: function () {
        hideErrorUpl();
        hideUploadMessage();
      },
      onSizeError: function () {
        msgReturn = cUplVars._uplSize_Error;
        msgReturn =
          msgReturn +
          " " +
          new Intl.NumberFormat("fr-FR", {
            maximumSignificantDigits: 3,
          }).format(convertSize(maxsize, "kb", "mb")) +
          "Mo";
        hideErrorUpl();
        showUploadMessage(msgReturn, "text-danger");
      },
      onExtError: function () {
        msgReturn = cUplVars._extension_Error;
        let extensionStrError = cform_uplAllowed.join(", ");
        msgReturn = msgReturn + " " + extensionStrError;
        hideErrorUpl();
        showUploadMessage(msgReturn, "text-danger");
      },
      onComplete: function (filename, response) {
        hideErrorUpl();
        hideProgressBar();
        if (!response) {
          showUploadMessage(cUplVars._general_Error, "text-danger");
          return;
        }

        if (typeof response.success != "undefined") {
          let nameUploaded = escapeTags(response.success.filename);
          previewName.text(nameUploaded);
          previewInput.val(response.success.record);
          elem.hide();
          previewArea.show();
        } else {
          if (typeof response.error != "undefined") {
            showUploadMessage(response.error, "text-danger");
          } else {
            showUploadMessage(cUplVars._general_Error, "text-danger");
          }
        }
      },
      onError: function (filename, type, status, statusText) {
        console.log(filename, type, status, statusText);
        hideErrorUpl();
        hideProgressBar();
        showUploadMessage(cUplVars._general_Error, "text-danger");
      },
    });
  }

  function escapeTags(str) {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  }
})(jQuery);

window.reCAPTCHACallback = function reCAPTCHACallback(token) {
  if ($("#recaptcha_field-error").length) {
    $("#recaptcha_field-error").remove();
  }
  lastRecaptchaResponse = token;
};

// datepicker_inline.js
$(function () {
  "use strict";
  //Datepicker embedded
  if ($("#date_booking").length) {
    var picker = $("#date_booking").daterangepicker({
      parentEl: "#daterangepicker-embedded-container",
      autoUpdateInput: false,
      autoApply: true,
      alwaysShowCalendars: true,
    });
    // range update listener
    picker.on("apply.daterangepicker", function (ev, picker) {
      $(this).val(
        picker.startDate.format("MM-DD-YY") +
          " to " +
          picker.endDate.format("MM-DD-YY")
      );
    });
    // prevent hide after range selection
    picker.data("daterangepicker").hide = function () {};
    // show picker on load
    picker.data("daterangepicker").show();
  }
});
